import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Moment from "react-moment";

import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  CircleMarker,
} from "react-leaflet";

import FleetWebApi from "../Api/FleetWebApi";

class CellTowerMap extends React.Component {
  static defaultProps = {
    startDate: new Date() - 12096e5, // now - 14 days
    endDate: new Date(),
  };
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      mappingDetails: null,
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.fetchCellTowerData();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.coreId !== this.props.coreId ||
      prevProps.virtualId !== this.props.virtualId ||
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      this.setState({ isLoaded: false, error: null, mappingDetails: null });
      this.fetchCellTowerData();
    }
  }
  fetchCellTowerData() {
    FleetWebApi.getCellTowerInformationFromCoreId(
      this.props.coreId,
      this.props.startDate,
      this.props.endDate,
      this.props.virtualId
    ).then(
      (result) => {
        if (this._isMounted) {
          this.setState({
            isLoaded: true,
            mappingDetails: result,
          });
        }
      },
      (error) => {
        if (this._isMounted) {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      }
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    let mapContainer;
    const { error, isLoaded, mappingDetails } = this.state;
    if (error) {
      mapContainer = <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      mapContainer = (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
    } else if (
      mappingDetails.device === null &&
      mappingDetails.towers.length === 0
    ) {
      mapContainer = <div>No data available</div>;
    } else {
      if (this.props.focused) {
        const position = mappingDetails.device
          ? [mappingDetails.device.latitude, mappingDetails.device.longitude]
          : [
              mappingDetails.towers[0].location.lat
                ? mappingDetails.towers[0].location.lat
                : 0,
              mappingDetails.towers[0].location.lon
                ? mappingDetails.towers[0].location.lon
                : 0,
            ];

        mapContainer = (
          <MapContainer center={position} zoom={15}>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <CircleMarker center={position}>
              <Popup>{mappingDetails.device?._id}</Popup>
            </CircleMarker>
            {mappingDetails.towers.map((tower, i) => (
              <Marker
                key={i}
                position={[
                  tower.location.lat ? tower.location.lat : 0,
                  tower.location.lon ? tower.location.lon : 0,
                ]}
              >
                <Popup>
                  Average Quality:{" "}
                  {tower.avg_qual ? tower.avg_qual.toFixed(2) : "Null"} <br />
                  Average RSSI:{" "}
                  {tower.avg_rssi ? tower.avg_rssi.toFixed(2) : "Null"} <br />
                  Average Strength:{" "}
                  {tower.avg_strength
                    ? tower.avg_strength.toFixed(2)
                    : "Null"}{" "}
                  <br />
                  Count: {tower.count ? tower.count : "Null"} <br />
                  <br />
                  Cell ID: {tower.cellId} <br />
                  Cell Operator: {tower.operator}
                  <br />
                  Access Technology: {tower.accessTechnology}
                  <br />
                  Last Connection:{" "}
                  {tower.timestamp ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss.SSS Z">
                      {tower.timestamp}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        );
      } else {
        mapContainer = <div>Waiting for focus</div>;
      }
    }
    const balance = mappingDetails?.balance;
    return (
      <Container maxWidth="lg" className="container" style={{ paddingBottom: 0 }}>
        <Grid item>
          <h3>Cell Locations for {this.props.coreId}</h3>
          {mapContainer}
          {balance ? (
            <Typography variant="caption" color="text.secondary">
              {!balance.limit_reached
                ? `Cell Tower API daily balance remaining: ${balance.balance}`
                : "API usage limits reached, please try again tomorrow."}
            </Typography>
          ) : null}
        </Grid>
      </Container>
    );
  }
}

export default CellTowerMap;
